var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    width: "1em",
    height: "1em",
    y: "0px",
    viewBox: "0 0 1150 1102",
    enableBackground: "new 0 0 1100 1052",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Theme",
    transform: "translate(75,75)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    fill: "currentcolor",
    d: "M916.9,24l60,60l-393,392.9L1024,916.8l-60,60L524,536.9L84,976.8l-60-60 l440-439.9L71.1,84l60-60L524,416.9L916.9,24z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseSm);
export default __webpack_public_path__ + "static/media/close-sm.adecc2066d2be884f1c71e141cf943a0.svg";
export { ForwardRef as ReactComponent };